import DefaultMapper, { addCustomMethods } from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';

class ApprovableAdminActionMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'system/approvableadminactions';
	}

	prepareCreate({ type, resource, params, options, mappedResource }) {
		options.method = 'POST';
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.id}${addCustomMethods(params)}`;
	}
};

export default ApprovableAdminActionMapper;
